"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPatchDigestSportVisibilityResponseDto = instanceOfPatchDigestSportVisibilityResponseDto;
exports.PatchDigestSportVisibilityResponseDtoFromJSON = PatchDigestSportVisibilityResponseDtoFromJSON;
exports.PatchDigestSportVisibilityResponseDtoFromJSONTyped = PatchDigestSportVisibilityResponseDtoFromJSONTyped;
exports.PatchDigestSportVisibilityResponseDtoToJSON = PatchDigestSportVisibilityResponseDtoToJSON;
exports.PatchDigestSportVisibilityResponseDtoToJSONTyped = PatchDigestSportVisibilityResponseDtoToJSONTyped;
/**
 * Check if a given object implements the PatchDigestSportVisibilityResponseDto interface.
 */
function instanceOfPatchDigestSportVisibilityResponseDto(value) {
    if (!('savedAt' in value) || value['savedAt'] === undefined)
        return false;
    if (!('sportCodes' in value) || value['sportCodes'] === undefined)
        return false;
    if (!('hiddenSportCodes' in value) || value['hiddenSportCodes'] === undefined)
        return false;
    if (!('sportCode' in value) || value['sportCode'] === undefined)
        return false;
    if (!('hidden' in value) || value['hidden'] === undefined)
        return false;
    return true;
}
function PatchDigestSportVisibilityResponseDtoFromJSON(json) {
    return PatchDigestSportVisibilityResponseDtoFromJSONTyped(json, false);
}
function PatchDigestSportVisibilityResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'savedAt': json['savedAt'],
        'sportCodes': json['sportCodes'],
        'hiddenSportCodes': json['hiddenSportCodes'],
        'sportCode': json['sportCode'],
        'hidden': json['hidden'],
    };
}
function PatchDigestSportVisibilityResponseDtoToJSON(json) {
    return PatchDigestSportVisibilityResponseDtoToJSONTyped(json, false);
}
function PatchDigestSportVisibilityResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'savedAt': value['savedAt'],
        'sportCodes': value['sportCodes'],
        'hiddenSportCodes': value['hiddenSportCodes'],
        'sportCode': value['sportCode'],
        'hidden': value['hidden'],
    };
}
